import { render } from "./AfsaCreateView.vue?vue&type=template&id=1db5c76e"
import script from "./AfsaCreateView.vue?vue&type=script&lang=js"
export * from "./AfsaCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__